// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {CofidisWidgetProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';

const options: ComponentOptionsType<CofidisWidgetProps> = {
  tag: 'monei-cofidis-widget',
  url: config.cofidisWidgetUrl,
  dimensions: {
    width: '100%',
    height: '46px'
  },
  autoResize: {
    width: false,
    height: true
  },
  prerenderTemplate: () => undefined,
  props: {
    accountId: {
      type: zoid.PROP_TYPE.STRING,
      required: true
    },
    amount: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    amountInt: {
      type: zoid.PROP_TYPE.NUMBER,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false,
      default: () => 'es'
    },
    showLogo: {
      type: zoid.PROP_TYPE.BOOLEAN,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    __onClick: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: () => {
        return (url: string) => {
          window.open(url, '_blank');
        };
      }
    }
  }
};

export const CofidisWidget: MoneiComponent<CofidisWidgetProps> = zoid.create(options);
